.editor {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: min(600px, 80vw);
  max-width: 90vw;
}

.title {
  text-align: center;
  font-size: 1.1rem;
}

.meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.metaLabel {
  font-size: 0.8rem;
  color: var(--text-text-secondary);
}

.metaValue {
  font-size: 0.95rem;
}

.modeHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.section {
  display: flex;
  flex-direction: column;
}

.radioGroup {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
  margin: 0.75rem 0 0;
}

.radioOption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;
  cursor: pointer;
  gap: 0.75rem;
}

.radioOption span {
  white-space: nowrap;
}

.radioOption input {
  accent-color: var(--color-primary-500);
}

.reverseButton {
  border: none;
  background: transparent;
  color: var(--text-color-gray-800);
  width: 2rem;
  height: 2rem;
  display: grid;
  place-items: center;
  border-radius: 999px;
  cursor: pointer;
}

.reverseButton:hover {
  color: var(--color-gray-900);
  background: var(--color-gray-100);
}

.reverseButton:focus-visible {
  outline: 2px solid var(--color-primary, #1f6eb3);
  outline-offset: 2px;
  background: var(--color-gray-100);
}

.baseColorRow {
  display: grid;
  grid-template-columns: 2rem minmax(0, 1fr);
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0;
}

.rows {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 320px;
  overflow-y: auto;
}

.row {
  display: grid;
  grid-template-columns: 2rem minmax(0, 1fr);
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--color-gray-300);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.96);
}

.rowLabel {
  min-width: 0;
}

.rowTitle {
  font-size: 0.95rem;
  font-weight: 500;
}

.rowSubtitle {
  font-size: 0.8rem;
  color: var(--text-color-gray-800);
}

.previewSwatch {
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  border: 1px solid var(--color-gray-500);
}

.emptyState {
  color: var(--color-gray-700);
  font-size: 0.9rem;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
